import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./IngredientsMgmt.module.css";
import { useNavigate } from "react-router-dom";
import actionicon from "../../../../../assets/images/actionicon.svg";
import filtericon from "../../../../../assets/images/filter.svg";
import {
  Dropdown,
  Modal,
  SearchInput,
  TextComponent,
} from "../../../../../components";
import { SubmitButton } from "../../../../../components";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import { ReactComponent as DeleteIcon } from "../../../../../assets/images/deleteIcon.svg";
import { ReactComponent as ViewIcon } from "../../../../../assets/images/view.svg";
import { ReactComponent as ArchiveIcon } from "../../../../../assets/images/archive.svg";

import { ReactComponent as EditIcon } from "../../../../../assets/images/editIcon.svg";
import { IoArchiveSharp } from "react-icons/io5";
import { FaRegEye } from "react-icons/fa";
import { BiSolidEdit } from "react-icons/bi";

const { Option } = Select;

const AdminBakerySetup = () => {
  const navigate = useNavigate();
  const [rowActions, setRowActions] = useState({});
  const [selectedActions, setSelectedActions] = useState({});
  const [isModal, setIsModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [Category, setCategory] = useState({
    value: "Flour",
    role: "Flour",
    id: 1,
  });
  const [statuss, setStatus] = useState({
    value: "Active",
    role: "active",
    id: 1,
  });
  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
    },
    {
      title: "Ingredient Name",
      dataIndex: "IngredientName",
      key: "IngredientName",
      render: (text, record) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
          {(record.IngredientName === "Bread Flour" ||
            record.IngredientName === "Margarine" ||
            record.IngredientName === "Almonds") && (
            <img src={actionicon} alt="icon" className={styles.iconImg} />
          )}
        </div>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
    },
    {
      title: "Category",
      key: "Category",
      dataIndex: "Category",
    },
    {
      title: "Shelf-life",
      key: "ShelfLife",
      dataIndex: "ShelfLife",
    },
    {
      title: "Action",
      key: "Action",
      dataIndex: "Action",
      render: (text, record) => (
        <div className={styles.itemsButtonDiv}>
          <ViewIcon
            className={styles.itemsButton}
            onClick={() => navigate("/Warehouse/AdjustStock")}
          />

          <EditIcon
            className={styles.itemsButton}
            onClick={() =>
              navigate("/Warehouse/IngredientsMgmt/EditIngredient")
            }
          />
          <ArchiveIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
        </div>
      ),
    },

    // {
    //   title: "",
    //   key: "button",
    //   dataIndex: "button",
    //   render: () => (
    //     <Button type="primary" className={styles.tableButton}>
    //       Continue
    //     </Button>
    //   ),
    // },
  ];

  const data = [
    {
      No: "1",
      IngredientName: "Bread Flour",
      Quantity: "2 lbs",
      Category: "Flour",
      ShelfLife: "180 days",
      Action: "View",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "2",
      IngredientName: "Instant Yeast",
      Quantity: "36 oz",
      Category: "Additives",
      ShelfLife: "2 years",
      Action: "Edit",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "3",
      IngredientName: "Brown sugar",
      Quantity: "3 lbs",
      Category: "Liquids",
      ShelfLife: "12 months",
      Action: "Archive",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "4",
      IngredientName: "Margarine",
      Quantity: "4 g",
      Category: "Toppings",
      ShelfLife: "180 days",
      Action: "Archive",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "5",
      IngredientName: "Olive oil",
      Quantity: "36 oz",
      Category: "Liquids",
      ShelfLife: "2 years",
      Action: "View",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "6",
      IngredientName: "Whole milk",
      Quantity: "3 lbs",
      Category: "Additives",
      ShelfLife: "12 months",
      Action: "View",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "7",
      IngredientName: "Almonds",
      Quantity: "2 lbs",
      Category: "Toppings",
      ShelfLife: "12 months",
      Action: "Edit",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "8",
      IngredientName: "Buttermilk",
      Quantity: "4 g",
      Category: "Liquids",
      ShelfLife: "180 Days",
      Action: "Archive",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "9",
      IngredientName: "Brown sugar",
      Quantity: "3 lbs",
      Category: "Toppings",
      ShelfLife: "2 years",
      Action: "View",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
  ];

  const handleDisplayFilter = () => {
    setShowFilter(true);
  };

  return (
    <div className={styles.mainCont}>
      {/* Heading Section with Right Controls */}
      <HeaderComponent
        heading={"Ingredients Management"}
        onSearch={(e) => console.log(e.target.value)}
        onClickFilter={() => handleDisplayFilter()}
        onSubmit={() =>
          navigate("/Warehouse/IngredientsMgmt/CreateNewGradient")
        }
        submitButtonText={" Create New Ingredient"}
        // showBackIcon={true}
        showFilterIcon={true}
        showSubmitButton={true}
        showSearch={true}
      />

      {/* Table Section */}
      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>

      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setIsModal(false)}
        onClickCancelButton={() => setIsModal(false)}
        okBtnTitle={"Yes"}
        cancelBtnTitle={"No"}
      >
        <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div>
      </Modal>
      <Modal
        open={showFilter}
        onClickOkButton={() => {
          setShowFilter(false);
        }}
        onCancel={() => setShowFilter(false)}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setShowFilter(false)}
        onClickCancelButton={() => setShowFilter(false)}
        okBtnTitle={"Apply Filters"}
        cancelBtnTitle={"Reset All"}
      >
        <Dropdown
          className={styles.input}
          label={"Category"}
          labelClass={styles.labelClass}
          value={Category}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Flour",
              role: "flour",
              id: 1,
            },
            {
              value: "Additives",
              role: "additives",
              id: 2,
            },
            {
              value: "Liquids",
              role: "liquids",
              id: 3,
            },
            {
              value: "Toppings",
              role: "Toppings",
              id: 3,
            },
          ]}
          onChange={(e) => setCategory(e)}
        />
        <Dropdown
          className={styles.input}
          label={"Status"}
          labelClass={styles.labelClass}
          value={statuss}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Active",
              role: "active",
              id: 1,
            },
            {
              value: "Archived",
              role: "archived",
              id: 2,
            },
          ]}
          onChange={(e) => setStatus(e)}
        />
      </Modal>
    </div>
  );
};

export default AdminBakerySetup;
